export function isPhotoEditingPanelSupported(zone: eXpress.core.IZone | null | undefined) {
	if (eXpress.core.isPhotoZone(zone)) {
		return !zone.isEmpty;
	}

	return false;
}
